exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-4567a01d] .composer-menu-area {\n  padding: 1.45rem 0 1.45rem 1.45rem;\n  min-height: 80vh;\n  max-width: 24rem;\n  display: grid;\n  grid-template-rows: min-content auto 2.5rem;\n}\n", ""]);

